import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { AptosWalletProvider } from '../AptosWalletProvider.types';

export const isAptosWalletProvider = (
  provider: WalletProvider | AptosWalletProvider
): provider is AptosWalletProvider => {
  return provider.chain === 'APTOS';
};
